import { createContext } from 'react';
/** @private Internal context. Do not use in your production. */
const SliderInternalContext = /*#__PURE__*/createContext({});
export default SliderInternalContext;